import { observable, IObservableArray, flow, toJS } from 'mobx';
import API from 'api';
import Prescriber from 'stores/Prescriber';
import Practice from 'stores/Practice';
import PrescriberPracticeContact from 'stores/PrescriberPracticeContact';

export default class PrescriberPractice {
	@observable id: number;
	@observable prescriberID: number;
	@observable practiceID: number;
	@observable modified: string;
	@observable disabled: boolean = false;
	@observable isDeleted: boolean = false;
	@observable Prescriber: Prescriber = new Prescriber();
	@observable Practice: Practice = new Practice();
	@observable PrescriberPracticeContacts: IObservableArray<PrescriberPracticeContact> = [];

	constructor(data: PrescriberPractice) {
		this.extend(data);
	}

	extend(data: JSON) {
		Object.assign(this, data);
	}

	update = flow(function*(withData) {
		if (withData) this.extend(withData);
		if (this.id) {
			// Update record
			yield API.patch(`/PrescriberPractices/${this.id}`, toJS(this));
		} else {
			// New record
			let result = yield API.post(`/PrescriberPractices`, toJS(this));
			this.id = result.id;
		}

		yield Promise.all(
			this.PrescriberPracticeContacts.map(ppc => {
				ppc.prescriberPracticeID = this.id;
				return new PrescriberPracticeContact(ppc).update();
			})
		);
	});

	static loadAllByUser(id: number): Promise<Array<PrescriberPractice>> {
		return new Promise((resolve, reject) => {
			API.get(
				`/AccountPrescriberPractices?filter=${JSON.stringify({
					where: { and: [{ accountID: id }, { disabled: false }] },
					include: { PrescriberPractice: ['Prescriber', { Practice: ['TherapeuticArea'] }] }
				})}`
			)
				.then(results => {
					resolve(results.map(el => new PrescriberPractice(el.PrescriberPractice)));
				})
				.catch(err => {
					reject(err);
				});
		});
	}
}



// WEBPACK FOOTER //
// ./src/stores/PrescriberPractice.js